(ns nosco.ui.text
  (:require
   [hx.react :refer [defnc]]
   [clojure.string :as string]
   [nosco.react :as nosco-react])
  (:require-macros
   [nosco.figma-utils]))

(nosco.figma-utils/defmap text-styles
  {Body-Lg-Bold "Body-Lg-Bold",
   Body-Lg-Italic "Body-Lg-Italic",
   Body-Lg-Regular "Body-Lg-Regular",
   Body-Lg-Underline "Body-Lg-Underline",
   Body-Md-Bold "Body-Md-Bold",
   Body-Md-Italic "Body-Md-Italic",
   Body-Md-Regular "Body-Md-Regular",
   Body-Md-Underline "Body-Md-Underline",
   Body-Sm-Bold "Body-Sm-Bold",
   Body-Sm-Italic "Body-Sm-Italic",
   Body-Sm-Regular "Body-Sm-Regular",
   Body-Sm-Underline "Body-Sm-Underline",
   Heading-2xl "Heading-2xl",
   Heading-3xl "Heading-3xl",
   Heading-Lg "Heading-Lg",
   Heading-Md "Heading-Md",
   Heading-Sm "Heading-Sm",
   Heading-Xl "Heading-Xl",
   Heading-Xsm "Heading-Xsm",
   Heading-Xxsm "Heading-Xxsm",
   Label-Button "Label-Button",
   Label-Button-Link "Label-Button-Link",
   Label-Field-Label "Label-Field-Label",
   Label-Field-Label-Md "Label-Field-Label-Md"})

;; TODO: Formalize the definition a bit more, and move to a different namespace
(defn classnames
  "Takes a base CSS class (string), and a list of maps where map keys are
   CSS modifiers parts (starting with --) and map values are booleans.

   For map keys where values are true, the CSS modifiers are included
   with the base CSS class prepended to each modifier.

   A list of CSS classes (as strings) is returned"
  [base & rest]
  (let [m (apply merge rest)]
    (conj
     (map
      #(str base %)
      (keys (select-keys m (for [[k v] m :when v] k))))
     base)))

(def valid-variants
  (set (vals text-styles)))

(defnc Text [{:keys [class children el variant truncate title style] :or {el :span}} ref]
  {:pre [(contains? valid-variants variant)]}
  (let [classes (classnames "nosco-text-label"
                            {"--truncate" truncate})
        classes (conj classes (str "nosco-text-label--" variant))]
    [el
     {:class (nosco-react/merge-class class classes)
      :style style
      :title title
      :ref ref}
     children]))

(nosco.react/forward-ref! Text)
